@if (updateForm) {
  <div class="d-flex flex-column h-100">
    <div class="d-flex flex-column w-100">
      <div class="d-flex flex-row align-items-center justify-content-between px-4 py-3 bg-white">
        @if (this.type_action === 'CREATE') {
          <h4 class="m-0 text-crm">
            {{ 'create_advert' | translate }}
          </h4>
        }
        @if (type_action !== 'CREATE') {
          <h4 class="m-0 text-crm">
            {{ 'change_advert' | translate }}
          </h4>
        }
        @if (baseService.isMobile) {
          <app-button (onChangeClick)="onCloseSidebar()" [btnType]="'icon'" matTooltip="{{ 'close' | translate }}">
            <app-icon>close</app-icon>
          </app-button>
        }
      </div>
      <mat-divider class="w-100"></mat-divider>
    </div>
    @if (isLoader) {
      <div class="d-flex w-100 h-100 align-items-center justify-content-center">
        <app-loader size="small"></app-loader>
      </div>
    } @else {
      <div class="d-flex flex-column h-100 w-100 overflow-auto crm-scroll">
        <div class="d-flex w-100 flex-column p-4 gap-3" [formGroup]="updateForm">
          <div class="form-group">
            <app-text-field
              label="{{ 'name' | translate }}"
              class="w-100"
              [type]="'default'"
              [required]="true"
              [error]="updateForm.controls.title.touched && updateForm.controls.title.invalid"
              [formControl]="updateForm.controls.title"
              (onValueChange)="updateForm.controls.title.markAsTouched()"
              (focusout)="updateForm.controls.title.markAsTouched()"
            ></app-text-field>
            <div class="d-flex justify-content-between">
              @if (updateForm.controls.title.touched && updateForm.controls.title.invalid) {
                <mat-hint class="text-danger">
                  @if (updateForm.controls.title.errors?.['required']) {
                    {{ 'field_cannot_be_empty' | translate }}
                  }
                  @if (updateForm.controls.title.errors?.['maxlength']) {
                    {{ 'max_value' | translate }} {{ updateForm.controls.title.errors?.['maxlength'].requiredLength }}
                  }
                  @if (updateForm.controls.title.errors?.['minlength']) {
                    {{ 'min_value' | translate }} {{ updateForm.controls.title.errors?.['minlength'].requiredLength }}
                  }
                </mat-hint>
              }
              <div class="flex-fill"></div>
              <mat-hint
                [ngClass]="{
                  'text-danger':
                    updateForm.controls.title.errors?.['minlength'] || updateForm.controls.title.errors?.['maxlength'],
                }"
                >{{ updateForm.controls.title.value?.length || 0 }}
              </mat-hint>
              <mat-hint>/70</mat-hint>
            </div>
          </div>
          <!--    Category-->
          <div>
            <div>
              @if (type_action === 'CREATE') {
                <label
                  class="label"
                  [ngClass]="{
                    'text-danger': updateForm.controls.category_id.touched && updateForm.controls.category_id.invalid,
                  }"
                  >{{ 'select_category' | translate }} <span class="required-star">*</span></label
                >
              }
              @if (type_action === 'UPDATE') {
                <label
                  class="label"
                  [ngClass]="{
                    'text-danger': updateForm.controls.category_id.touched && updateForm.controls.category_id.invalid,
                  }"
                  >{{ 'selected_category' | translate }} <span class="required-star">*</span></label
                >
              }
            </div>
            @if (type_action === 'CREATE') {
              <div class="d-flex flex-column">
                <div class="d-flex flex-wrap gap-3 w-100">
                  @for (category of categories; track category; let i = $index) {
                    <app-dropdown
                      class="w-25"
                      [items]="category"
                      (onValueChange)="selectCategory($event, i)"
                      [closeOnSelect]="true"
                      [placeholder]="'Виберіть категорію'"
                      [formControl]="updateForm.controls.category_id"
                      (focusout)="updateForm.controls.category_id.markAllAsTouched()"
                    ></app-dropdown>
                  }
                </div>
                <div>
                  @if (updateForm.controls.category_id.touched && updateForm.controls.category_id.invalid) {
                    <mat-hint class="text-danger">
                      @if (updateForm.controls.category_id.errors?.['required']) {
                        {{ 'field_cannot_be_empty' | translate }}
                      }
                    </mat-hint>
                  }
                </div>
              </div>
            }
            @if (type_action === 'UPDATE') {
              <div class="d-flex flex-wrap gap-3 w-100">
                <span>{{ this.current_category }}</span>
              </div>
            }
          </div>
          <div>
            <div>
              @if (type_action === 'CREATE' || type_action === 'UPDATE') {
                <label
                  class="label"
                  [ngClass]="{
                    'text-danger':
                      (updateForm.controls.location.controls.city_id.touched &&
                        updateForm.controls.location.controls.city_id.invalid) ||
                      (updateForm.controls.location.controls.district_id.touched &&
                        updateForm.controls.location.controls.district_id.invalid),
                  }"
                >
                  {{ type_action === 'CREATE' ? ('select_city' | translate) : ('selected_city' | translate)
                  }}<span class="required-star">*</span>
                </label>
              }
            </div>
            <div class="d-flex gap-3 w-100">
              @if (type_action === 'CREATE' || isChangeCity) {
                <app-dropdown
                  class="w-25"
                  [items]="cities"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  [bindLabelOption]="'fullname'"
                  [bindValue]="'city_id'"
                  (onValueChange)="selectCity($event)"
                  (onScrollDropdown)="scrollToEndCity()"
                  (onSearchDropdown)="searchCity($event)"
                  [placeholder]="'Виберіть місто'"
                  [formControl]="updateForm.controls.location.controls.city_id"
                  (focusout)="updateForm.controls.location.controls.city_id.markAllAsTouched()"
                ></app-dropdown>
              }
              @if (current_city !== '' && isDistrict) {
                @if (type_action === 'CREATE' || isChangeCity) {
                  <app-dropdown
                    class="w-25"
                    [items]="districts"
                    [closeOnSelect]="true"
                    [searchable]="true"
                    (onValueChange)="selectDistrict($event)"
                    (onScrollDropdown)="scrollToEndDistrict()"
                    (onSearchDropdown)="searchDistrict($event)"
                    [placeholder]="'Виберіть регіон'"
                    [formControl]="updateForm.controls.location.controls.district_id"
                    (focusout)="updateForm.controls.location.controls.district_id.markAllAsTouched()"
                  ></app-dropdown>
                }
              }
              @if (type_action === 'UPDATE' && !isChangeCity) {
                <span>{{ this.advert.city.name }} {{ this.advert.city.municipality }}</span>
                <a (click)="isChangeCity = true" class="text-crm change-city">Обрати інше місто</a>
              }
            </div>
            @if (
              updateForm.controls.location.controls.city_id.touched &&
              updateForm.controls.location.controls.city_id.invalid
            ) {
              <mat-hint class="text-danger">
                @if (updateForm.controls.location.controls.city_id.errors?.['required']) {
                  {{ 'field_cannot_be_empty' | translate }}
                }
              </mat-hint>
            }
            @if (
              updateForm.controls.location.controls.district_id.touched &&
              updateForm.controls.location.controls.district_id.invalid
            ) {
              <mat-hint class="text-danger">
                @if (updateForm.controls.location.controls.district_id.errors?.['required']) {
                  {{ 'field_cannot_be_empty' | translate }}
                }
              </mat-hint>
            }
            <!--      <mat-hint class="text-danger" *ngIf="updateForm.controls.location.controls.city_id.invalid">-->
            <!--        <ng-container *ngIf="updateForm.controls.location.controls.city_id.errors?.['required']">-->
            <!--          {{ 'field_cannot_be_empty' | translate }}-->
            <!--        </ng-container>-->
            <!--      </mat-hint>-->
            <!--      <mat-hint class="text-danger" *ngIf="updateForm.controls.location.controls.district_id.invalid && !updateForm.controls.location.controls.city_id.untouched">-->
            <!--        <ng-container *ngIf="updateForm.controls.location.controls.district_id.errors?.['required']">-->
            <!--          {{ 'field_cannot_be_empty' | translate }}-->
            <!--        </ng-container>-->
            <!--      </mat-hint>-->
          </div>
          @if (photos_limit !== 0) {
            <div class="form-group">
              <label class="label">{{ 'add_photos' | translate }}</label>
              <div
                cdkDropList
                cdkDropListOrientation="mixed"
                class="example-list crm-scroll"
                (cdkDropListDropped)="drop($event)"
              >
                @for (img of images; track img; let i = $index) {
                  <div class="d-flex">
                    <div class="example-box move" cdkDrag>
                      <app-button btnType="icon" class="deletePhoto" (click)="deletePhoto(i)">
                        <app-icon>delete</app-icon>
                      </app-button>
                      <img class="container-img no-select" [src]="img.url" alt="{{ i }}" />
                      @if (i === 0) {
                        <div class="main-badge">
                          <label class="label no-select position-absolute text w-100">{{ 'main' | translate }}</label>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (images.length < photos_limit) {
                  @for (empty of blocks; track empty) {
                    <div class="photo-block">
                      <div class="example-box click">
                        <div class="container-img bg-light">
                          <div
                            (click)="openFileUpload()"
                            class="h-100 d-flex justify-content-center align-items-center"
                          >
                            <label class="label no-select">{{ 'add_photo' | translate }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          }
          <div class="form-group">
            <label
              class="label"
              [ngClass]="{
                'text-danger': updateForm.controls.description.touched && updateForm.controls.description.invalid,
              }"
              >{{ 'description' | translate }} <span class="required-star">*</span></label
            >
            <textarea
              cdkTextareaAutosize
              class="w-100 description-area crm-scroll"
              maxlength="9000"
              [formControl]="updateForm.controls.description"
              (ngModelChange)="updateForm.controls.description.markAsTouched()"
              (focusout)="updateForm.controls.description.markAsTouched()"
            ></textarea>
            <div class="d-flex justify-content-between">
              @if (updateForm.controls.description.touched && updateForm.controls.description.invalid) {
                <mat-hint class="text-danger">
                  @if (updateForm.controls.description.errors?.['required']) {
                    {{ 'field_cannot_be_empty' | translate }}
                  }
                  @if (updateForm.controls.description.errors?.['minlength']) {
                    {{ 'min_value' | translate }}
                    {{ updateForm.controls.description.errors?.['minlength'].requiredLength }}
                  }
                  @if (updateForm.controls.description.errors?.['maxlength']) {
                    {{ 'max_value' | translate }}
                    {{ updateForm.controls.description.errors?.['maxlength'].requiredLength }}
                  }
                </mat-hint>
              }
              <div class="flex-fill"></div>
              <mat-hint>{{ updateForm.controls.description.value?.length || 0 }}/9000</mat-hint>
            </div>
          </div>
          <div class="form-group d-flex flex-column">
            <label class="label" [ngClass]="{ 'text-danger': priceTypeControl.touched && priceTypeControl.invalid }"
              >{{ 'price' | translate }} <span class="required-star">*</span></label
            >
            <div class="d-flex flex-column gap-2">
              <app-dropdown
                [items]="OLX_PRICE_TYPES"
                [closeOnSelect]="true"
                bindValue="value"
                [isTranslate]="true"
                [formControl]="priceTypeControl"
                (onValueChange)="setChoice($event); priceTypeControl.markAsTouched()"
                (focusout)="priceTypeControl.markAsTouched()"
                [error]="priceTypeControl.touched && priceTypeControl.invalid"
              ></app-dropdown>
              @if (priceTypeControl.touched && priceTypeControl.invalid) {
                <mat-hint class="text-danger">
                  @if (priceTypeControl.errors?.['required']) {
                    {{ 'field_cannot_be_empty' | translate }}
                  }
                </mat-hint>
              }
              @if (priceTypeControl.value === 'price') {
                <div class="d-flex flex-column gap-2">
                  <div class="d-flex gap-2 align-items-center">
                    <app-price-field
                      mask="separator.2"
                      [formControl]="updateForm.controls.price.controls.value"
                      (onValueChange)="updateForm.controls.price.controls.value.markAsTouched()"
                      (focusout)="updateForm.controls.price.controls.value.markAsTouched()"
                      [Error]="
                        updateForm.controls.price.controls.value.touched &&
                        updateForm.controls.price.controls.value.invalid
                      "
                    ></app-price-field>
                    <app-dropdown
                      [items]="CURRENCY"
                      bindValue="value"
                      [closeOnSelect]="true"
                      [formControl]="updateForm.controls.price.controls.currency"
                      (onValueChange)="updateForm.controls.price.controls.currency.markAsTouched()"
                      (focusout)="updateForm.controls.price.controls.currency.markAsTouched()"
                      [error]="
                        updateForm.controls.price.controls.currency.touched &&
                        updateForm.controls.price.controls.currency.invalid
                      "
                    ></app-dropdown>
                  </div>
                  @if (
                    (updateForm.controls.price.controls.value.touched &&
                      updateForm.controls.price.controls.value.invalid) ||
                    (updateForm.controls.price.controls.currency.touched &&
                      updateForm.controls.price.controls.currency.invalid)
                  ) {
                    <mat-hint class="text-danger">
                      @if (
                        updateForm.controls.price.controls.value.errors?.['required'] ||
                        updateForm.controls.price.controls.currency.errors?.['required']
                      ) {
                        {{ 'field_cannot_be_empty' | translate }}
                      }
                      @if (updateForm.controls.price.controls.value.errors?.['too_high_advert_price']) {
                        {{ 'errors.too_high_advert_price' | translate }}
                      }
                      @if (updateForm.controls.price.controls.currency.errors?.['advert_cannot_specified_currency']) {
                        {{ 'errors.advert_cannot_specified_currency' | translate }}
                      }
                    </mat-hint>
                  }
                  <app-checkbox [formControl]="updateForm.controls.price.controls.negotiable">
                    {{ 'negotiable' | translate }}
                  </app-checkbox>
                </div>
              }
            </div>
          </div>
          <div>
            <div>
              <app-text-field
                label="{{ 'contact_name' | translate }}"
                [formControl]="updateForm.controls.contact.controls.name"
                [required]="true"
                (onValueChange)="updateForm.controls.contact.controls.name.markAsTouched()"
                (focusout)="updateForm.controls.contact.controls.name.markAsTouched()"
                [error]="
                  updateForm.controls.contact.controls.name.touched && updateForm.controls.contact.controls.name.invalid
                "
              ></app-text-field>
            </div>
            @if (
              updateForm.controls.contact.controls.name.touched && updateForm.controls.contact.controls.name.invalid
            ) {
              <mat-hint class="text-danger">
                @if (updateForm.controls.contact.controls.name.errors?.['required']) {
                  {{ 'field_cannot_be_empty' | translate }}
                }
              </mat-hint>
            }
          </div>
          <div>
            <div>
              <app-phone-field
                label="{{ 'phone' | translate }}"
                [formControl]="updateForm.controls.contact.controls.phone"
                (valueChanged)="updateForm.controls.contact.controls.phone.markAsTouched()"
                (focusout)="updateForm.controls.contact.controls.phone.markAsTouched()"
                [error]="
                  updateForm.controls.contact.controls.phone.touched &&
                  updateForm.controls.contact.controls.phone.invalid
                "
                [placeholder]="'+380 '"
              ></app-phone-field>
            </div>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="d-flex flex-row align-items-center justify-content-between px-4 py-3 bg-white top-0 z-5">
          <h4 class="m-0 text-crm">
            {{ 'additional_information' | translate }}
          </h4>
        </div>
        @if (attributeForm) {
          <div class="d-flex flex-column justify-content-center pt-2 pb-4 px-4 gap-2" [formGroup]="attributeForm">
            <label class="label">{{ 'private_or_business' | translate }}<span class="required-star">*</span></label>
            <mat-button-toggle-group
              [formControl]="updateForm.controls.advertiser_type"
              name="advertiser_type"
              class="d-flex gap-5"
              appearance="legacy"
            >
              @if (
                updateForm.controls.advertiser_type.touched ||
                (updateForm.controls.advertiser_type.value !== 'business' &&
                  updateForm.controls.advertiser_type.untouched)
              ) {
                <mat-button-toggle value="private">
                  {{ 'private_person' | translate }}
                </mat-button-toggle>
              }
              <mat-button-toggle value="business">
                {{ 'business' | translate }}
              </mat-button-toggle>
            </mat-button-toggle-group>
            @for (attribute of dataAttributes; track attribute) {
              <div class="d-flex flex-column gap-2">
                <label
                  class="label"
                  [ngClass]="{
                    'text-danger':
                      attributeForm.controls[attribute.code].touched && attributeForm.controls[attribute.code].invalid,
                  }"
                  >{{ attribute.label }}
                  @if (attribute.validation.required) {
                    <span class="required-star">*</span>
                  }
                </label>
                @if (attribute.values.length > 2 && !attribute.validation.allow_multiple_values) {
                  <app-dropdown
                    bindValue="code"
                    bindLabel="label"
                    bindLabelOption="label"
                    [closeOnSelect]="true"
                    [items]="attribute.values"
                    [formControl]="attributeForm.controls[attribute.code]"
                    (focusout)="attributeForm.controls[attribute.code].markAsTouched()"
                    [error]="
                      attributeForm.controls[attribute.code].touched && attributeForm.controls[attribute.code].invalid
                    "
                  ></app-dropdown>
                }
                @if (
                  attribute.values.length <= 2 &&
                  !attribute.validation.allow_multiple_values &&
                  !attribute.validation.numeric
                ) {
                  <mat-button-toggle-group
                    [formControl]="attributeForm.controls[attribute.code]"
                    (focusout)="attributeForm.controls[attribute.code].markAsTouched()"
                    name="advertiser_type"
                    class="d-flex gap-5"
                    appearance="legacy"
                  >
                    @for (value of attribute.values; track value) {
                      <mat-button-toggle value="{{ value.code }}">
                        {{ value.label }}
                      </mat-button-toggle>
                    }
                  </mat-button-toggle-group>
                }
                @if (attribute.values.length === 0) {
                  @if (!attribute.validation.max && !attribute.validation.numeric) {
                    <app-text-field
                      class="w-100"
                      [type]="'default'"
                      [placeholder]="attribute.unit"
                      [formControl]="attributeForm.controls[attribute.code]"
                      (focusout)="attributeForm.controls[attribute.code].markAsTouched()"
                      [error]="
                        attributeForm.controls[attribute.code].touched && attributeForm.controls[attribute.code].invalid
                      "
                    ></app-text-field>
                  }
                  @if (attribute.validation.numeric) {
                    <app-text-field
                      class="w-100"
                      [mask]="'separator' + '2'"
                      [thousandSeparator]="''"
                      [decimalMarker]="','"
                      [placeholder]="attribute.unit"
                      [type]="'default'"
                      [formControl]="attributeForm.controls[attribute.code]"
                      (focusout)="attributeForm.controls[attribute.code].markAsTouched()"
                      [error]="
                        attributeForm.controls[attribute.code].touched && attributeForm.controls[attribute.code].invalid
                      "
                    ></app-text-field>
                  }
                }
                @if (attribute.validation.allow_multiple_values) {
                  @for (value of attribute.values; track value) {
                    <div>
                      <app-checkbox
                        (focusout)="attributeForm.controls[attribute.code].markAsTouched()"
                        [ngModel]="attributeForm.controls[attribute.code].value.includes(value.code)"
                        (ngModelChange)="checkItem(attribute.code, value.code)"
                        [ngModelOptions]="{ standalone: true }"
                      >
                        {{ value.label }}
                      </app-checkbox>
                    </div>
                  }
                }
                @if (attributeForm.controls[attribute.code].touched && attributeForm.controls[attribute.code].invalid) {
                  <mat-hint class="text-danger">
                    @if (attributeForm.controls[attribute.code]?.errors?.['required']) {
                      {{ 'field_cannot_be_empty' | translate }}
                    }
                    @if (attributeForm.controls[attribute.code]?.errors?.['max']) {
                      {{ 'max_value' | translate }} {{ attribute.validation.max }}
                    }
                    @if (attributeForm.controls[attribute.code]?.errors?.['min']) {
                      {{ 'min_value' | translate }} {{ attribute.validation.min }}
                    }
                  </mat-hint>
                }
              </div>
            }
          </div>
        }
      </div>
    }
    <div class="d-flex flex-column w-100">
      <mat-divider class="w-100"></mat-divider>
      <div class="bg-white d-flex justify-content-center align-items-center gap-2 p-4">
        <app-button [customClass]="'bg-danger'" btnType="cancel" (onChangeClick)="cancel()"
          >{{ 'cancel' | translate }}
        </app-button>
        <div class="flex-fill"></div>
        @if (type_action === 'CREATE') {
          <div class="d-flex w-100 d-flex justify-content-between">
            @if (this.planned_at) {
              <app-button btnType="icon" (onChangeClick)="cancelPlanner()" [matTooltip]="'cancel' | translate">
                <app-icon>event_busy</app-icon>
              </app-button>
            }
            @if (!this.planned_at) {
              <app-button btnType="icon" (onChangeClick)="openPlanner()">
                <app-icon>calendar_month</app-icon>
              </app-button>
            }
          </div>
        }
        @if (this.is_planner && type_action === 'UPDATE') {
          <app-button
            [disabled]="['CREATED', 'COMPLETED'].includes($safeNavigationMigration(this.advert?.status))"
            (onChangeClick)="save(true)"
            >{{ 'publish_now' | translate }}
          </app-button>
        }
        @if (!this.planned_at) {
          <app-button (onChangeClick)="save()">{{ 'save' | translate }}</app-button>
        }
        @if (this.planned_at) {
          <app-button (onChangeClick)="save()">{{ 'to_plan' | translate }}</app-button>
        }
      </div>
    </div>
  </div>
}
